import { render, staticRenderFns } from "./common-plot.vue?vue&type=template&id=0d60e3e0&scoped=true&"
import script from "./common-plot.vue?vue&type=script&lang=js&"
export * from "./common-plot.vue?vue&type=script&lang=js&"
import style0 from "./common-plot.vue?vue&type=style&index=0&id=0d60e3e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d60e3e0",
  null
  
)

export default component.exports